import {
  TRANSFER_FUNDS_INTERNAL_ERROR,
  TRANSFER_FUNDS_INTERNAL_START,
  TRANSFER_FUNDS_INTERNAL_SUCCESS,
  TRANSFER_FUNDS_INTERNAL_CLEAR,
} from 'constants/action-types/moneyTransfer';

export default (state, { type, payload }) => {
  switch (type) {
    case TRANSFER_FUNDS_INTERNAL_START:
      return {
        ...state,
        transferFundsInternal: {
          ...state.transferFundsInternal,
          loading: true,
          error: null,
        },
      };
    case TRANSFER_FUNDS_INTERNAL_ERROR:
      return {
        ...state,
        transferFundsInternal: {
          ...state.transferFundsInternal,
          error: payload,
          loading: false,
        },
      };
    case TRANSFER_FUNDS_INTERNAL_SUCCESS:
      return {
        ...state,
        transferFundsInternal: {
          ...state.transferFundsInternal,
          error: null,
          loading: false,
          data: payload,
        },
      };

    case TRANSFER_FUNDS_INTERNAL_CLEAR:
      return {
        ...state,
        transferFundsInternal: {
          ...state.transferFundsInternal,
          error: null,
          loading: false,
          data: null,
        },
      };
    default:
      return null;
  }
};
